var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36 2.094a.75.75 0 0 0-.726 0l-7.087 3.91A1.063 1.063 0 0 0 3.063 8h13.871a1.065 1.065 0 0 0 .516-1.998zM9.13 6.5H4.753l5.244-2.894L15.24 6.5h-4.378a.999.999 0 1 0-1.731 0M3.997 9v5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h12.25c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-.25V9h-1.5v5h-2V9h-1.5v5h-2V9h-1.5v5h-2V9zm-1 7.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h14.25c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75z"
  })));
};
export default SvgBank;